import React from 'react';
import Loadable from 'react-loadable';
import { useParams } from 'react-router';
import { sortBy } from 'lodash';
import { getOperations } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import {
  getArea,
  getPositionMatrix,
  getPositions,
  getYardsNotDeleted,
  getObjectTypesNotDeleted,
  getSelfManagedTeamsNotDeleted,
} from './api';

export const path = '/area/:id';
export const getPath = (id: string | number) => `/area/${id}`;

const PagePositionMatrix: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import('./page'),
      area: () => getArea(+id),
      matrix: () => getPositionMatrix({ areaId: +id }),
      positions: getPositions,
      operations: () => getOperations({ areaId: +id }),
      yards: getYardsNotDeleted,
      objectTypes: getObjectTypesNotDeleted,
      selfManagedTeams: getSelfManagedTeamsNotDeleted,
    },
    loading: LoadableLoading,
    render(loaded: any, loadedProps: {}) {
      const Page = loaded.page.default;

      return (
        <Page
          {...loadedProps}
          area={loaded.area}
          matrix={loaded.matrix}
          operations={loaded.operations}
          yards={loaded.yards}
          objectTypes={loaded.objectTypes}
          selfManagedTeams={loaded.selfManagedTeams}
          positions={sortBy(
            loaded.positions.map(({ positionId, positionName }: { positionId: number; positionName: string }) => ({
              value: positionId,
              label: positionName,
            })),
            'label',
          )}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PagePositionMatrix;
